import React, {Fragment, useState, useEffect} from "react";

import './PrivateMessagingTab.scss';
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

import DropdownOrganisationUsers from "root/ReactHookForm/ui/DropdownOrganisationUsers";
import DropdownConnectedUsers from "root/ReactHookForm/ui/DropdownConnectedUsers";
import MessagesTable from "root/Tables/MessagesTable";
import {getMonitoringMessages} from "root/DataFunctions/MessageDataFns";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";
import {MessageType} from "root/DataFunctions/Constants";

const PrivateMessagingTab = (props) =>
{
    const [data, setData] = useState({isLoading: true, data: []});

    const [currentTargetUser, setCurrentTargetUser] = useState(null);
    const [currentConnectedUser, setCurrentConnectedUser] = useState(null);

    const [renderAddMessagingModal, showAddMessagingModal] = useModalAddPost((result) =>
    {
        if(result === 'saved'){
            getData();
        }
    })

    useEffect(() => {
        if (currentTargetUser !== null && currentConnectedUser !== null )
        {
            getData();
        }
    }, [currentTargetUser, currentConnectedUser]);

    const getData = () => {
        getMonitoringMessages(currentTargetUser, currentConnectedUser, (response) =>
        {
            const data = getDataFromResponse(response);
            setData({isLoading: false, data: data});
        });
    }

    const onUserChange = (e) =>
    {
        setCurrentTargetUser(e.enc_user_id);
        setCurrentConnectedUser(null);
        console.log(e);
    }

    const onConnectedChange = (e) =>
    {
        setCurrentConnectedUser(e.enc_user_id);
        console.log(e);
    }


    const messageClickHandler = (mode, child_uid, message_id) =>
    {
        showAddMessagingModal(mode, child_uid, message_id, false, MessageType.MESSAGE_TYPE_MESSAGE, null);
    }

    const showDataTable = ( currentTargetUser !== null && currentConnectedUser !== null ) ;

    return (
        <Fragment>
            <div className="family-body">

                <div className='row'>
                    <div className='col-md-6'>
                        <div style={{marginBottom: '10px'}}>
                            <label>First User</label>
                            <DropdownOrganisationUsers readOnly={false} onChange={onUserChange} initialValue={null}
                                                       mode={props.mode} name='org_users'
                                                       placeholder='Please select a user'
                                                       isSearchable={true}
                                                       isClearable={true}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div style={{marginBottom: '10px'}}>
                            <label>Connected User</label>
                            <DropdownConnectedUsers enc_user_id={currentTargetUser}
                                                    readOnly={currentTargetUser === null} onChange={onConnectedChange}
                                                    initialValue={null}
                                                    mode={props.mode} name='org_users'
                                                    placeholder='Please select a user'
                                                    isSearchable={true}
                                                    isClearable={true}/>
                        </div>
                    </div>
                </div>

                { showDataTable === true && <MessagesTable child_uid={currentTargetUser} unenc_child_uid={1} loading={data.isLoading}
                               data={data.data} clickHandler={messageClickHandler} showFullMessage={true}/> }

                {renderAddMessagingModal()}
            </div>

        </Fragment>
    )
}

PrivateMessagingTab.defaultProps = {};

export default PrivateMessagingTab;

